export default __webpack_public_path__ + "static/media/logo-tcego.17fafe5d.svg";